import FixturesWidget from './FixturesWidget.js'
import Fixtures from './Fixtures.js'

const initSportData = () => {
    const fixturesWidgetEl = document.querySelector('#fixtures-widget');
    const fixturesEl = document.querySelector('#fixtures');

    // Mount FixturesWidget
    const mountFixturesWidget = () => {
        const { createApp } = Vue

        createApp(FixturesWidget).mount('#fixtures-widget')
    }

    if (fixturesWidgetEl) {
        mountFixturesWidget()
    }

    // Mount Fixtures
    const mountFixtures = () => {
        const { createApp } = Vue

        createApp(Fixtures).mount('#fixtures')
    }

    if (fixturesEl) {
        mountFixtures()
    }
}

export default initSportData;